import DOMPurify from 'dompurify'; 


const allowedHtmlElements = ['a', '!DOCTYPE', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base',
    'bdi', 'bdo', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd',
    'del', 'details', 'dfn', 'dialogue', 'div', 'dl', 'dt', 'em', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2',
    'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr',  'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li',
    'main', 'map', 'mark', 'menu', 'meter', 'nav', 'noscript', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre',
    'progress', 'q', 'rt', 'rp', 'ruby', 's', 'samp', 'search', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary',
    'sup', 'svg', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var',
    'wbr', 'animate','animateColor','animateMotion','animateTransform','circle','defs',
    'desc','ellipse','font-face','font-face-name','font-face-src','g','glyph','hkern','image','linearGradient',
    'line','marker','metadata','missing-glyph','mpath','path','polygon','polyline','radialGradient','rect','set',
    'stop','svg','switch','text','title','tspan','use', 'atmentions', 'at-popup'
]


const allowedattrbutes = [
    'background','cite','href','longdesc','poster','src','usemap','xlink:href',
    'abbr','align','allowfullscreen','alt','axis','bgcolor','border','cellpadding','cellspacing','class','clear',
    'color','cols','colspan','compact','controls','coords','data-chrome','data-dnt','data-flickr-embed','data-id',
    'data-widget-id','dir','face','frameborder','headers','height','hreflang','hspace','ismap','lang','language',
    'nohref','nowrap','rel','rev','rows','rowspan','rules','scope','scrolling','shape','size','span','start',
    'summary','target','title','type','valign','value','vspace','width','style',
    'accent-height','accumulate','additive','alphabetic','arabic-form','ascent',
    'attributeName','attributeType','baseProfile','bbox','begin','by','calcMode','cap-height','color',
    'color-rendering','content','cx','cy','d','dx','dy','descent','display','dur','end','fill','fill-rule','font-family',
    'font-size','font-stretch','font-style','font-variant','font-weight','from','fx','fy','g1','g2','glyph-name',
    'gradientUnits','hanging','height','horiz-adv-x','horiz-origin-x','ideographic','k','keyPoints',
    'keySplines','keyTimes','lang','marker-end','marker-mid','marker-start','markerHeight','markerUnits',
    'markerWidth','mathematical','max','min','offset','opacity','orient','origin','overline-position',
    'overline-thickness','panose-1','path','pathLength','points','preserveAspectRatio','r','refX','refY',
    'repeatCount','repeatDur','requiredExtensions','requiredFeatures','restart','rotate','rx','ry','slope','stemh',
    'stemv','stop-color','stop-opacity','strikethrough-position','strikethrough-thickness','stroke',
    'stroke-dasharray','stroke-dashoffset','stroke-linecap','stroke-linejoin','stroke-miterlimit',
    'stroke-opacity','stroke-width','systemLanguage','target','text-anchor','to','transform','type','u1','u2',
    'underline-position','underline-thickness','unicode','unicode-range','units-per-em','values','version',
    'viewBox','visibility','width','widths','x','x-height','x1','x2','xlink:actuate','xlink:arcrole','xlink:role',
    'xlink:show','xlink:title','xlink:type','xml:base','xml:lang','xml:space','xmlns','xmlns:xlink','y','y1','y2',
    'zoomAndPan', 'allow', 'allowfullscreen', 'frameborder', 'scrolling', 'data-flickr-embed', 'id'
];

const config = {
    ADD_TAGS: allowedHtmlElements,
    ALLOWED_TAGS: allowedHtmlElements, // only <P> and text nodes
    KEEP_CONTENT: true, // remove content from non-allow-listed nodes too
    ADD_ATTR: allowedattrbutes, // permit kitty-litter attributes
  };

function addScript(src: string) {
    
    const script = document.createElement('script');

    script.src = src;
    script.async = true;

    document.body.appendChild(script)
}

export function purifyMarkup(html: string) {
    return DOMPurify.sanitize(html, config);
}

export function purifyMarkupNoTags(html: string) {
    return DOMPurify.sanitize(html, {ALLOWED_TAGS:[], KEEP_CONTENT: true});
}

export function attachKnownSafeScripts(html: string){
    const hasFlickr = html.indexOf('data-flickr-embed') !== -1;
    const hasTwitter = html.indexOf('class="twitter-') !== -1;
    const hasPlaybuzz = html.indexOf('playbuzz') !== -1 && html.indexOf('data-id') !== -1             

    if (hasFlickr) {
        addScript("https://embedr.flickr.com/assets/client-code.js")
    }

    if (hasTwitter) {
        addScript("https://platform.twitter.com/widgets.js")
       
        if ((window as any)['twttr']) {
            (window as any)?.twttr?.widgets?.load();
        }
      }

    if (hasPlaybuzz) {
        addScript("https://embed.playbuzz.com/sdk.js");
    }
}